<template>
  <div class="peoduct_box">
    <div
      class="item"
      v-for="(item, index) in productList"
      :key="index"
      @mouseenter="activeProduct = index + 1"
      @mouseleave="activeProduct = ''"
      @click="getProductDetails(item.uuid)"
    >
      <div class="img_box">
        <img :src="item.imgUrl ? item.imgUrl : '../../../assets/home/cp_icon.png'" style="height: 220px"/>
        <div v-if="activeProduct == index + 1" class="copyImg"></div>
        <span v-if="activeProduct == index + 1" class="name_b">{{
          item.name
        }}</span>
      </div>
      <span class="name">{{ item.name }}</span>
      <div class="cs_box">
        <div class="ele" v-for="(ele, ind) in item.params" :key="ind">
          <span>{{ ele.name + "：" }}</span>
          <span>{{ ele.value }}{{ ele.unit }}</span>
        </div>
      </div>
      <span class="company">{{ item.company }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productList: Array,
    page: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeProduct: false,
    };
  },
  methods: {
    getProductDetails(uuid) {
            let routeData = this.$router.resolve({
        name: "seriesDetails",
      });
      let href = routeData.href + "?uuid=" + uuid;
      window.open(href, "_blank");
    }
  }
};
</script>

<style scoped lang="less">
.peoduct_box {
  display: flex;
  flex-wrap: wrap;
  .item {
    flex: 0 0 calc(100% / 4 - 40px);
    background: rgb(249, 249, 249);
    border-radius: 10px;
    box-shadow: 4px 4px 10px #dddcdc;
    cursor: pointer;
    padding: 10px;
    overflow: hidden;
    text-align: center;
    margin-right: 20px;
    margin-bottom: 20px;
    .img_box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 100%;
      }
      .copyImg {
        width: 100%;
        height: 220px;
        background: #43434378;
        position: absolute;
        top: 0;
      }
      .name_b {
        position: absolute;
        bottom: 100px;
        padding: 8px 15px;
        border: 1px solid #fff;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .name {
      width: 100%;
      font-size: 16px;
      display: inline-block;
      color: #333333;
      font-weight: 600;
      margin: 15px 0;
      letter-spacing: 1px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .cs_box {
      border-top: 1px solid rgba(215, 215, 215, 1);
      border-bottom: 1px solid rgba(215, 215, 215, 1);
      padding: 10px 20px;
      .ele {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999999;
      }
      .ele:last-child {
        margin-bottom: 0;
      }
    }
    .company {
      color: #999999;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
      margin-top: 15px;
      display: inline-block;
    }
  }
  .item:hover {
    img,.copyImg {
      transform: scale(1.1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/components/Product.vue